import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import GameCarousel from "../../components/GameCarousel";
import { GamesAPI } from "../../api/games";
import PreLoader from "../../components/PreLoader";
//@ts-ignore
import logo from "../../assets/logo-white.png";
import { useTranslation } from "react-i18next";

const Games = () => {
  const { t } = useTranslation();
  const [games, setGames] = useState<any[]>();

  useEffect(() => {
    async function fetchGames() {
      try {
        const res = await GamesAPI.getActive();
        if (res.data) {
          setGames(res.data);
          const data = res.data;
          const newArray = data.map(
            (item: {
              picture: string;
              contentName: string;
              externalLink: string;
            }) => ({
              image: item.picture,
              name: item.contentName,
              externalLink: item.externalLink,
            })
          );

          setGames(newArray);
        }
      } catch (error) {
        console.log("Something went wrong. Try Again!");
      }
    }
    fetchGames();
  }, []);

  if (!games) return <PreLoader />;

  return (
    <Container
      fluid
      className="m-0 flex flex-col w-full items-center text-white"
    >
      {/* Navbar */}
      <section className="w-full lg:w-[75%] lg:mt-[2rem] mb-2">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
      </section>
      {games && (
        <section className="w-full lg:w-[75%] flex flex-col justify-center items-center">
          <h2 className="mt-[5rem] mb-3 text-[1.6rem] lg:text-[2.5rem] font-defaultFont text-center">
            {t("best_games")}
          </h2>

          <GameCarousel games={games} />
        </section>
      )}
    </Container>
  );
};

export default Games;
